import React, { useEffect, useState } from "react";

import DocMngt from "../../resources/docMngt";
import Foundation from "../../resources/foundation";
import LandingHeader from "./LandingHeader";
import Layout1 from "../../assets/layout_1.png";
import Layout2 from "../../assets/layout_2.png";
import Loader from "../common/Loader/Loader";
import Notification from "../../resources/notification";
import SelfVerification from "../../resources/selfVerification";
import Surveys from "../../resources/surveys";
import { getResources } from "../../services/user-services/user-level-services";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import worldIcon from "../../assets/world.png";

const LandingPage = () => {
    const [resources, setResources] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);

    const layoutData = [
        {
            name: "Layout One",
            id: 100,
            selected: false,
            imageUrl: Layout1,
            color: "#F5F5F5",
        },
        {
            name: "Layout Two",
            id: 101,
            selected: false,
            imageUrl: Layout2,
            color: "#E6E6FA",
        },
    ];
    const isEntraLogin = localStorage.getItem("isEntraLogin") === "true";
    const { instance, accounts } = useMsal();

    useEffect(() => {
        if (isEntraLogin === true) {
            getEntraToken();
        } else {
            getResourcesList();
        }
        sessionStorage.setItem("isUserSurveysQuePageOpen", 'false');
        const event = new Event('sessionStorageUpdated1');
        window.dispatchEvent(event);
    }, []);

    useEffect(() => {
        let isWarningModalShown = sessionStorage.getItem('surveyWarningShown');
        if(isWarningModalShown && isWarningModalShown === 'true') return;
        else setIsWarningModalOpen(true)
    }, [])

    const getEntraToken = async () => {
        const isUserSurveyPresent = "userSurveyInfo" in localStorage;
        const isUserDocPresent = "userDocInfo" in sessionStorage;

        if (isUserSurveyPresent || isUserDocPresent) {
            // Chnages for redirecting to user survey page after login
            const activeAccount = accounts[0];
            instance.setActiveAccount(activeAccount);

            const tokenResponse = await instance.acquireTokenSilent({
                account: activeAccount,
                scopes: ["User.Read"], // Replace with your actual scopes
            });
            // localStorage.setItem('isMasalTokenInStorage', true);
            localStorage.setItem(
                "msal-token-storage",
                JSON.stringify(tokenResponse.idToken)
            );

            let docurl = "";
            const userSurveyInfo = JSON.parse(
                localStorage.getItem("userSurveyInfo") || "{}"
            );
            const userDocInfo =  JSON.parse(sessionStorage.getItem("userDocInfo") || "{}");
            if (isUserSurveyPresent) {
                docurl =
                    "/survey/" +
                    userSurveyInfo?.surveyId +
                    "/" +
                    userSurveyInfo?.code +
                    "/" +
                    userSurveyInfo?.languageId;
                navigate(docurl);
            } else if (isUserDocPresent) {
                // Build FileViewer route and navigate
                const fileName = encodeURIComponent(userDocInfo.userDocument);
                const accessibilityLevel = userDocInfo.accessibilityLevel;
                const fileViewerRoute = `/view-document/${fileName}?accessibilityLevel=${accessibilityLevel}`;
                navigate(fileViewerRoute);
            }
        } else {
            getResourcesList();
        }
    };

    const getResourcesList = async () => {
        setLoading(true);
        const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey") === "true";
        const resp = await getResources();
        if (resp?.statusCode === 200) {
            if (!isExternalUserSurvey) {
                navigate("/home");
            }
            setLoading(false);
            // onLogin();
            setResources(resp.data[0].resources);
            localStorage.setItem("userDetails", JSON.stringify(resp.data));
            sessionStorage.setItem("layoutData", JSON.stringify(layoutData)); // Set survey layout details
            sessionStorage.setItem("isExternalUserSurvey", false);
            sessionStorage.setItem("isSurveyResponseSubmitted", false);
            localStorage.removeItem("userSurveyInfo");
        } else {
            setLoading(false);
        }
    };

    const hasResource = (code) =>
        resources.some((res) => res.resourceCode === code);

    return (
        <>
            {loading && <Loader />}
            <div className="landing-page">
                <LandingHeader />
                <div className="centered-container">
                    <svg
                        width="1000"
                        height="4"
                        viewBox="0 0 1282 4"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginBottom: "-2.5rem" }}
                    >
                        {/* <line
                            y1="2"
                            x2="1285.5"
                            y2="2"
                            stroke="#C80000"
                            strokeWidth="4"
                        /> */}
                    </svg>

                    <svg
                        className="dotPattern"
                        width="1600"
                        height="400"
                        viewBox="0 0 1600 432"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g style={{ mixBlendMode: "hard-light" }}>
                            <path
                                d="M1800 0H0V550H1120L1800 0Z"
                                fill="url(#paint0_linear_620_834)"
                                fillOpacity="0.92"
                            />
                        </g>
                        <foreignObject x="50" y="50" width="1600" height="500">
                            <div xmlns="http://www.w3.org/1999/xhtml">
                                <div className="landing-page-buttons-container">
                                    {hasResource("SELFVERIFICATION") && (
                                        <SelfVerification />
                                    )}
                                    {hasResource("DOCUMENT") && <DocMngt />}
                                    {hasResource("SURVEY") && <Surveys />}
                                    {hasResource("FOUNDATION") && (
                                        <Foundation />
                                    )}
                                    {hasResource("NOTIFICATION") && (
                                        <Notification />
                                    )}
                                </div>
                            </div>
                        </foreignObject>
                        <defs>
                            <linearGradient
                                id="paint0_linear_620_834"
                                x1="800"
                                y1="138.5"
                                x2="800"
                                y2="432"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#1D0000" stopOpacity="0.9" />
                                <stop
                                    offset="0.5"
                                    stopColor="#FF0303"
                                    stopOpacity="0.57"
                                />
                                <stop offset="1" stopOpacity="0.11" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div className="landing-footer">
                    <div className="footer-powered">{t("poweredBy")}</div>
                    <div className="landing-footer-text clipped-footer">
                        <strong className="footer-organization">
                            {t("hitachiGCO")}
                        </strong>
                    </div>
                </div>
            </div>

            <ModalComponent
                modalTitle={<>Notice</>}
                modalText={
                    <>
                        <div style={{fontWeight: '500'}}>
                            <span>
                                Kindly click on the globe icon 
                                <img
                                    src={worldIcon}
                                    alt="Languages"
                                    className="globe"
                                    style={{ margin: "2px 2px -3px" }}
                                />     
                                to view application in Japanese or Simplified Chinese if needed.</span>
                        </div>
                        <div style={{marginTop: '2rem', fontWeight: '500'}}>
                            <span>
                                必要に応じて、地球儀アイコン 
                                <img
                                    src={worldIcon}
                                    alt="Languages"
                                    className="globe"
                                    style={{ margin: "2px 0px -2px" }}
                                /> 
                                をクリックして、アプリケーションを日本語または中国語（簡体字）で表示してください。</span>
                        </div>
                        <div style={{marginTop: '2.5rem', fontWeight: '500'}}>
                            <span>
                                如需查看日语或简体中文版本的应用程序，请点击地球图标。
			                    <img
                                    src={worldIcon}
                                    alt="Languages"
                                    className="globe"
                                    style={{ margin: "0px 0px -2px" }}
                                /> 
                            </span>
                        </div>
                    </>
                }
                fieldsData={<></>}
                isOpen={isWarningModalOpen}
                onClose={() => {
                    setIsWarningModalOpen(false);
                    sessionStorage.setItem('surveyWarningShown', 'true');
                }}
            />
        </>
    );
};

export default LandingPage;
